<mat-form-field appearance="outline" class="w-100 prefix-select" (click)="focusOnPrefix()">
    <mat-label>{{"input-additional-phone-prefix-label" | translate}}</mat-label>
    <mat-select (selectionChange)="selectTriggered($event)" [(value)]="prefixFound" [disabled]="wait">
        <mat-select-trigger *ngIf="prefixFound" class="d-flex justify-content-center align-items-center">
            <span class="icp-flag-circle-{{prefixFound.stateCode}} icp-icon-16 me-2"></span>{{prefixFound.prefix}}
        </mat-select-trigger>
        <div class="sticky-top w-100 prefix-select-filter pt-2 px-2 bg-white">
            <div class="position-relative d-flex align-items-center">
                <input #prefixFocus class="w-100 prefix-select__input-text" placeholder="{{'prefix-search-hint' | translate}}" [(ngModel)]="filter" (keyup)="filterPrefixes()">
                <i class="icp-icon-20 icp-search position-absolute" style="right: 10px"></i>
            </div>
        </div>
        <mat-option *ngFor="let p of filteredPrefixes" class="prefix-select-width" [value]="p">
            <div class="d-flex align-items-center">
                <div class="icp-flag-circle-{{p.stateCode}} icp-icon-16 me-2"></div><div class="text-truncate">{{p.prefix}} - {{helpersService.config.REGISTRATION_COUNTRY_PREFIX + p.stateCode | translate}}</div>
            </div>
            </mat-option>
    </mat-select>
</mat-form-field>